import { Phone, Mail, Calendar, Circle } from 'lucide-react'
import { ACTIVITY_TYPE_COLORS } from '@/lib/theme'

/**
 * Icon for a task subtype (Task / Call / Email / Meeting / Other), using the
 * Grackle brand palette (ACTIVITY_TYPE_COLORS) so a task's kind is recognisable
 * at a glance:
 *   Call → phone (Teal), Email → mail (Plum), Meeting → calendar (Evergreen),
 *   Other → circle (neutral grey). A plain "Task" (or unknown) returns null —
 *   callers show the label text alone.
 *
 * Decorative by default (`aria-hidden`); the accessible name comes from the
 * adjacent type label text.
 */
export function getTaskTypeIcon(type?: string, className = 'h-4 w-4') {
  switch (type) {
    case 'Call':
      return (
        <Phone
          className={className}
          style={{ color: ACTIVITY_TYPE_COLORS.Call.solid }}
          aria-hidden="true"
        />
      )
    case 'Email':
      return (
        <Mail
          className={className}
          style={{ color: ACTIVITY_TYPE_COLORS.Email.solid }}
          aria-hidden="true"
        />
      )
    case 'Meeting':
      return (
        <Calendar
          className={className}
          style={{ color: ACTIVITY_TYPE_COLORS.Event.solid }}
          aria-hidden="true"
        />
      )
    case 'Other':
      return <Circle className={`${className} text-gray-500`} aria-hidden="true" />
    default:
      return null
  }
}
